@import 'styles/mixins';
@import 'styles/variables';

.container {
  align-items: center;
  background: linear-gradient(270deg, var(--Magenta-50, #b64bf8) 0%, var(--Blue-70, #0179cf) 100%),
    var(--background, #f3f5f6);
  display: flex;
  gap: 10px;
  left: 0;
  justify-content: center;
  padding: 8px 10px;
  position: absolute;
  right: 0;
  top: 0;
  min-height: 48px;

  @media (max-width: $phoneMaxWidth) {
    min-height: 68px;
  }

  &.blackFridayCta {
    background: var(--dark-100);
  }
}

.message {
  @include for-phone-only {
    width: 280px;
    max-width: calc(100vw - 140px);
  }
}

.close {
  position: absolute;
  display: flex;
  align-items: center;
  height: 100%;
  top: 0;
  bottom: 0;
  right: 8px;

  button {
    padding: 0px;
    width: 22px;
    height: 22px;
    min-height: unset;
  }
}

.buttonContainer {
  background: var(--light-100);
  border-radius: 6px;
}
